import { Fragment, useMemo } from "react";
import CustomSelect from "../../../../../CommonComponents/CustomSelect"
import CustomToolTip from "../../../../../CommonComponents/CustomToolTip";
import { GenerateNewKeySvg, InfoIcon } from "../../../../../CommonComponents/svgs/Svgs";
import { generate32ByteValue } from "../../../../../../utils/commonFunctions";
import { getAllEncriptionNames, getSecurityKeyInputNames, handleKeyDown, handlePaste } from "../../../../../CommonComponents/security-configuration/helperFunctions";
import useSecurityConfig from "../../../../hooks/useSecurityConfig";

const OPTIONS = [
    { value: 'authentication_1', label: 'Authentication 1' },
    { value: 'authentication_2', label: 'Authentication 2' },
    { value: 'encryption_1', label: 'Encryption 1' },
    { value: 'encryption_2', label: 'Encryption 2' },
    { value: 'encryption_3', label: 'Encryption 3' },
]

interface SecurityConfigFormProps {
    DROPDOWN_CONTAINER_CLASS: string;
    CONSOLE_SELECT_PROPS: {
        background: string;
        controllHeight: string;
    };
}

const SecurityConfigForm = ({ DROPDOWN_CONTAINER_CLASS, CONSOLE_SELECT_PROPS }: SecurityConfigFormProps) => {

    const { securityConfig, securityConfigFormData, setSecurityConfigFormData, getRelatedSecurityIndex, EncripTionOptions } = useSecurityConfig()

    const { taskType, keyType, keyValue, keyExchangeType } = useMemo(() => ({ ...securityConfigFormData }), [securityConfigFormData])
    const showInputSection = useMemo(() => taskType && taskType?.value.includes('upload'), [taskType])
    const KeyInputOptions = useMemo(() => securityConfig ? getSecurityKeyInputNames(securityConfig) : OPTIONS, [securityConfig, OPTIONS])

    const onKeyTypeChange = (data: { label: string, value: string }) => {
        const options = securityConfig ? getAllEncriptionNames(securityConfig) : EncripTionOptions;
        const filterdOptions = getRelatedSecurityIndex(options, data);
        const selected = filterdOptions[0];
        setSecurityConfigFormData((prev) => ({ ...prev!, keyType: data, encriptionKey: selected }))
    }

    if (!securityConfigFormData) return null
    return (
        <div className='d-flex flex-column gap-3 w-100'>
            <div className={DROPDOWN_CONTAINER_CLASS}>
                <span className="input__label">Key Type</span>
                <CustomSelect
                    options={KeyInputOptions}
                    value={keyType}
                    placeholder="Select Key Type"
                    onChange={onKeyTypeChange}
                    isSearchable={false}
                    {...CONSOLE_SELECT_PROPS}
                />
            </div>
            {showInputSection &&
                <Fragment>
                    <div className='d-flex w-100 align-items-center justify-content-between'>
                        <span className="input__label d-flex gap-1">Key Input
                            <CustomToolTip title="Generate a new key">
                                <InfoIcon />
                            </CustomToolTip>
                        </span>
                        <div className="form__group__button__container">
                            {['key', 'seed'].map((item) => (
                                <button key={item} className={`__group__button ${keyExchangeType === item ? 'active' : ''}`}
                                    onClick={() => {
                                        const value = item as 'key' | 'seed'
                                        setSecurityConfigFormData((prev) => ({ ...prev!, keyExchangeType: value, keyValue: '' }))
                                    }}
                                >
                                    {item}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className='d-flex w-100 align-items-center justify-content-end'>
                        <div className="console__form__field__container">
                            <input
                                disabled={!keyType}
                                value={keyValue}
                                minLength={64}
                                maxLength={64}
                                placeholder={`Enter ${keyExchangeType}`}
                                className="__form__field__input"
                                // type={keyExchangeType === 'key' ? 'text' : 'number'} // This code may be used in the future.
                                type={'text'}
                                onKeyDown={(e) => handleKeyDown(e, keyExchangeType!)}
                                onPaste={(e) => handlePaste(e, (value) => setSecurityConfigFormData((prev) => ({ ...prev!, keyValue: value })))}
                                onChange={(e) => setSecurityConfigFormData((prev) => ({ ...prev!, keyValue: e.target.value }))}
                            />
                            <button className="__form__field__button"
                                disabled={!keyType}
                                onClick={() => {
                                    const value = generate32ByteValue(keyExchangeType!)
                                    setSecurityConfigFormData((prev) => ({ ...prev!, keyValue: value }))
                                }}
                            >
                                <GenerateNewKeySvg />
                            </button>
                        </div>
                    </div>
                </Fragment>
            }
        </div>
    )
}

export default SecurityConfigForm